(function () {
  var cfg = window.OV_CMP_CONFIG || {};
  var selectors = {
    root: "[data-cmp-root]",
    banner: "[data-cmp-banner]",
    modal: "[data-cmp-modal]",
    modalPanel: "[data-cmp-modal-panel]",
    manage: "[data-cmp-open]",
    allowAll: "[data-cmp-allow-all]",
    allowSelection: "[data-cmp-allow-selection]",
    necessaryOnly: "[data-cmp-necessary-only]",
    save: "[data-cmp-save]",
    close: "[data-cmp-modal-close]",
    toggle: "[data-cmp-toggle]"
  };

  var state = {
    api: null,
    gtmLoaded: false,
    gaLoaded: false,
    consentDefaultSet: false,
    modalRestoreTarget: null,
    nativeLinksObserver: null
  };
  var nativeBannerDismissCfg = {
    storageKey: "ov_cmp_native_banner_dismissed_at",
    durationMs: 24 * 60 * 60 * 1000
  };

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[CMP]");
    console.log.apply(console, args);
  }

  function bySel(sel, root) {
    return (root || document).querySelector(sel);
  }

  function bySelAll(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function setVisible(el, visible) {
    if (!el) return;
    el.hidden = !visible;
  }

  function getBool(val) {
    return val === true || val === "true" || val === 1;
  }

  function getRootDataset() {
    var root = bySel(selectors.root);
    return root ? root.dataset || {} : {};
  }

  function getLegalLinkConfig() {
    var ds = getRootDataset();
    return {
      privacyUrl: "/pages/datenschutzerklarung",
      withdrawalUrl: "/pages/widerrufsbelehrung",
      imprintUrl: "/pages/impressum",
      privacyLabel: ds.cmpPrivacyLabel || "Privacy policy",
      withdrawalLabel: ds.cmpWithdrawalLabel || "Withdrawal policy",
      imprintLabel: ds.cmpImprintLabel || "Imprint"
    };
  }

  function getNativeBannerDescription() {
    var text = (getRootDataset().cmpDescription || "").trim();
    return text || null;
  }

  function ensureNativeBannerBodyDescription(banner) {
    if (!banner) return;
    var bodyPolicyLink = banner.querySelector("#shopify-pc__banner__body-policy-link");
    if (!bodyPolicyLink) return;

    var paragraph = bodyPolicyLink.parentElement;
    if (!paragraph) return;

    var description = getNativeBannerDescription();
    if (!description) return;
    if (paragraph.getAttribute("data-ov-cmp-description") === description) return;

    paragraph.textContent = "";
    paragraph.appendChild(document.createTextNode(description + " "));
    paragraph.appendChild(bodyPolicyLink);
    paragraph.setAttribute("data-ov-cmp-description", description);
  }

  function getCloseButtonLabel() {
    return getRootDataset().cmpCloseLabel || "Close";
  }

  function hideNativeBanner() {
    var banner = document.getElementById("shopify-pc__banner");
    if (!banner) return;
    banner.hidden = true;
    banner.style.display = "none";
    banner.setAttribute("aria-hidden", "true");
  }

  function setNativeBannerDismissedAt(timestamp) {
    try {
      window.localStorage.setItem(nativeBannerDismissCfg.storageKey, String(timestamp));
    } catch (e) {}
  }

  function clearNativeBannerDismissedAt() {
    try {
      window.localStorage.removeItem(nativeBannerDismissCfg.storageKey);
    } catch (e) {}
  }

  function isNativeBannerDismissed() {
    var raw = null;
    try {
      raw = window.localStorage.getItem(nativeBannerDismissCfg.storageKey);
    } catch (e) {
      return false;
    }
    if (!raw) return false;

    var dismissedAt = parseInt(raw, 10);
    if (isNaN(dismissedAt)) {
      clearNativeBannerDismissedAt();
      return false;
    }

    var stillSuppressed = Date.now() - dismissedAt < nativeBannerDismissCfg.durationMs;
    if (!stillSuppressed) clearNativeBannerDismissedAt();
    return stillSuppressed;
  }

  function dismissNativeBannerFor24h() {
    setNativeBannerDismissedAt(Date.now());
    hideNativeBanner();
    syncDismissedConsentMode();
    log("native banner dismissed for 24h");
  }

  function ensureNativeBannerLegalLinks() {
    var banner = document.getElementById("shopify-pc__banner");
    if (!banner) return;
    var legalCfg = getLegalLinkConfig();
    ensureNativeBannerBodyDescription(banner);
    var bodyPolicyLink = banner.querySelector("#shopify-pc__banner__body-policy-link");
    if (bodyPolicyLink && bodyPolicyLink.getAttribute("href") !== legalCfg.privacyUrl) {
      bodyPolicyLink.setAttribute("href", legalCfg.privacyUrl);
    }
    var actionWrap = banner.querySelector(".shopify-pc__banner__btns-granular, .shopify-pc__banner__btns");
    if (!actionWrap) return;
    if (actionWrap.querySelector("[data-ov-cmp-legal-links]")) return;

    var linksWrap = document.createElement("div");
    linksWrap.className = "ov-cmp-legal-links";
    linksWrap.setAttribute("data-ov-cmp-legal-links", "true");

    var privacyLink = document.createElement("a");
    privacyLink.href = legalCfg.privacyUrl;
    privacyLink.textContent = legalCfg.privacyLabel;

    var withdrawalLink = document.createElement("a");
    withdrawalLink.href = legalCfg.withdrawalUrl;
    withdrawalLink.textContent = legalCfg.withdrawalLabel;

    var imprintLink = document.createElement("a");
    imprintLink.href = legalCfg.imprintUrl;
    imprintLink.textContent = legalCfg.imprintLabel;

    linksWrap.appendChild(privacyLink);
    linksWrap.appendChild(withdrawalLink);
    linksWrap.appendChild(imprintLink);
    actionWrap.appendChild(linksWrap);
    log("native legal links injected");
  }

  function ensureNativeBannerCloseButton() {
    var banner = document.getElementById("shopify-pc__banner");
    if (!banner) return;
    if (banner.querySelector("[data-ov-cmp-close]")) return;

    var closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "ov-cmp-close";
    closeBtn.setAttribute("data-ov-cmp-close", "true");
    closeBtn.setAttribute("aria-label", getCloseButtonLabel());
    closeBtn.textContent = "×";
    closeBtn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      dismissNativeBannerFor24h();
    });

    banner.appendChild(closeBtn);
    log("native close button injected");
  }

  function ensureNativeBannerEnhancements() {
    ensureNativeBannerLegalLinks();
    ensureNativeBannerCloseButton();
    if (isNativeBannerDismissed()) hideNativeBanner();
  }

  function watchNativeBannerLegalLinks() {
    ensureNativeBannerEnhancements();
    if (state.nativeLinksObserver || !document.body) return;
    state.nativeLinksObserver = new MutationObserver(function () {
      ensureNativeBannerEnhancements();
    });
    state.nativeLinksObserver.observe(document.body, { childList: true, subtree: true });
  }

  function ensureDataLayer() {
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
  }

  function loadScript(src, marker) {
    if (document.querySelector('script[data-cmp-marker="' + marker + '"]')) return;
    var script = document.createElement("script");
    script.async = true;
    script.src = src;
    script.setAttribute("data-cmp-marker", marker);
    document.head.appendChild(script);
  }

  function loadGTM() {
    if (state.gtmLoaded) return;
    var gtmId = (cfg.gtmId || "").trim();
    if (!gtmId) return;
    ensureDataLayer();
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    loadScript("https://www.googletagmanager.com/gtm.js?id=" + encodeURIComponent(gtmId), "cmp-gtm");
    state.gtmLoaded = true;
    log("loadGTM", { gtmId: gtmId });
  }

  function loadGA() {
    if (state.gaLoaded) return;
    var gaId = (cfg.gaId || "").trim();
    if (!gaId) return;
    ensureDataLayer();
    loadScript("https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(gaId), "cmp-ga4");
    window.gtag("js", new Date());
    window.gtag("config", gaId);
    state.gaLoaded = true;
    log("loadGA", { gaId: gaId });
  }

  function getAllowedProcessing() {
    if (!state.api) return null;
    try {
      return {
        preferences: state.api.preferencesProcessingAllowed ? !!state.api.preferencesProcessingAllowed() : false,
        analytics: state.api.analyticsProcessingAllowed ? !!state.api.analyticsProcessingAllowed() : false,
        marketing: state.api.marketingAllowed ? !!state.api.marketingAllowed() : false,
        saleOfData: state.api.saleOfDataAllowed ? !!state.api.saleOfDataAllowed() : true
      };
    } catch (e) {
      return null;
    }
  }

  function toConsentModePayload(allowed) {
    if (!allowed) return null;
    var adEnabled = allowed.marketing && allowed.saleOfData;
    return {
      analytics_storage: allowed.analytics ? "granted" : "denied",
      ad_storage: allowed.marketing ? "granted" : "denied",
      functionality_storage: allowed.preferences ? "granted" : "denied",
      personalization_storage: allowed.preferences ? "granted" : "denied",
      ad_user_data: adEnabled ? "granted" : "denied",
      ad_personalization: adEnabled ? "granted" : "denied",
      security_storage: "granted"
    };
  }

  function getDeniedConsentModePayload() {
    return {
      analytics_storage: "denied",
      ad_storage: "denied",
      functionality_storage: "denied",
      personalization_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      security_storage: "granted"
    };
  }

  function syncDismissedConsentMode() {
    ensureDataLayer();
    var payload = getDeniedConsentModePayload();
    window.gtag("consent", "update", payload);
    window.dataLayer.push({
      event: "cmp_consent_updated",
      cmp_consent_mode: "dismissed",
      cmp_consent: payload
    });
    log("syncDismissedConsentMode", payload);
  }

  function syncGtmConsentMode(mode) {
    if (!state.api) return;
    var allowed = getAllowedProcessing();
    var payload = toConsentModePayload(allowed);
    if (!payload) return;
    ensureDataLayer();
    window.gtag("consent", mode, payload);
    window.dataLayer.push({
      event: "cmp_consent_updated",
      cmp_consent_mode: mode,
      cmp_consent: payload
    });
    log("syncGtmConsentMode", { mode: mode, payload: payload });
  }

  function applyScriptGate() {
    if (!state.api) return;
    if (isNativeBannerDismissed()) {
      log("applyScriptGate skipped by 24h dismiss window");
      return;
    }
    var allowed = getAllowedProcessing();
    if (!allowed) return;
    log("applyScriptGate", allowed);
    if (allowed.analytics) loadGA();
    if (allowed.analytics || allowed.marketing) loadGTM();
  }

  function readCurrentConsent() {
    var defaults = { preferences: false, analytics: false, marketing: false };
    if (!state.api || !state.api.currentVisitorConsent) return defaults;
    var current = state.api.currentVisitorConsent() || {};
    var preferences = current.preferences === "yes";
    var analytics = current.analytics === "yes";
    var marketing = current.marketing === "yes";

    if (current.preferences === "" && state.api.preferencesProcessingAllowed) {
      preferences = !!state.api.preferencesProcessingAllowed();
    }
    if (current.analytics === "" && state.api.analyticsProcessingAllowed) {
      analytics = !!state.api.analyticsProcessingAllowed();
    }
    if (current.marketing === "" && state.api.marketingAllowed) {
      marketing = !!state.api.marketingAllowed();
    }

    return {
      preferences: preferences,
      analytics: analytics,
      marketing: marketing
    };
  }

  function fillModalFromConsent(root) {
    var consent = readCurrentConsent();
    bySelAll(selectors.toggle, root).forEach(function (input) {
      var key = input.getAttribute("data-cmp-toggle");
      if (!key) return;
      input.checked = !!consent[key];
    });
  }

  function collectModalSelection(root) {
    var payload = { preferences: false, analytics: false, marketing: false };
    bySelAll(selectors.toggle, root).forEach(function (input) {
      var key = input.getAttribute("data-cmp-toggle");
      if (!key) return;
      payload[key] = !!input.checked;
    });
    return payload;
  }

  function setBusy(root, busy) {
    [
      selectors.allowAll,
      selectors.allowSelection,
      selectors.necessaryOnly,
      selectors.save
    ].forEach(function (sel) {
      var el = bySel(sel, root);
      if (el) el.disabled = busy;
    });
  }

  function showBanner(root) {
    setVisible(bySel(selectors.banner, root), true);
  }

  function hideBanner(root) {
    setVisible(bySel(selectors.banner, root), false);
  }

  function getFocusable(panel) {
    if (!panel) return [];
    return bySelAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      panel
    );
  }

  function isModalOpen(root) {
    var modal = bySel(selectors.modal, root);
    return !!(modal && !modal.hidden);
  }

  function openModal(root, triggerEl) {
    fillModalFromConsent(root);
    log("openModal", { consent: readCurrentConsent() });
    var modal = bySel(selectors.modal, root);
    var panel = bySel(selectors.modalPanel, root);
    if (!modal) return;
    state.modalRestoreTarget = triggerEl || document.activeElement;
    setVisible(modal, true);
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("cmp-modal-open");
    var focusable = getFocusable(panel);
    if (focusable.length) {
      focusable[0].focus();
    } else if (panel) {
      panel.focus();
    }
  }

  function closeModal(root) {
    var modal = bySel(selectors.modal, root);
    if (!modal) return;
    setVisible(modal, false);
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cmp-modal-open");
    if (state.modalRestoreTarget && state.modalRestoreTarget.focus) {
      state.modalRestoreTarget.focus();
    }
    log("closeModal");
  }

  function trapModalTab(root, event) {
    if (event.key !== "Tab" || !isModalOpen(root)) return;
    var panel = bySel(selectors.modalPanel, root);
    var focusable = getFocusable(panel);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var current = document.activeElement;

    if (event.shiftKey && current === first) {
      event.preventDefault();
      last.focus();
      return;
    }
    if (!event.shiftKey && current === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function applyConsent(root, payload) {
    if (!state.api || !state.api.setTrackingConsent) return;
    log("applyConsent:request", payload);
    setBusy(root, true);
    state.api.setTrackingConsent(payload, function (result) {
      setBusy(root, false);
      log("applyConsent:result", result);
      log("currentVisitorConsent", state.api.currentVisitorConsent ? state.api.currentVisitorConsent() : null);
      if (result && result.error) return;
      hideBanner(root);
      closeModal(root);
      setVisible(bySel(selectors.manage, root), false);
      syncGtmConsentMode("update");
      applyScriptGate();
    });
  }

  function bindGlobalOpenHandler(root) {
    document.addEventListener("click", function (event) {
      var target = event.target;
      if (!target) return;
      if (!target.closest && target.parentElement) target = target.parentElement;
      if (!target.closest) return;

      var trigger = target.closest("[data-cmp-open-settings], a[href='#cookie-settings']");
      if (trigger) {
        event.preventDefault();
        openModal(root, trigger);
        return;
      }

      var link = target.closest("a");
      if (!link) return;
      if ((link.textContent || "").trim().toLowerCase() === "cookie-einstellungen") {
        event.preventDefault();
        openModal(root, link);
      }
    });
  }

  function initUI(root) {
    if (!root) return;

    var banner = bySel(selectors.banner, root);
    var manage = bySel(selectors.manage, root);
    setVisible(manage, false);

    var allowAll = bySel(selectors.allowAll, root);
    var allowSelection = bySel(selectors.allowSelection, root);
    var necessaryOnly = bySel(selectors.necessaryOnly, root);
    var save = bySel(selectors.save, root);
    var modalCloseEls = bySelAll(selectors.close, root);

    if (allowAll) {
      allowAll.addEventListener("click", function () {
        applyConsent(root, { preferences: true, analytics: true, marketing: true });
      });
    }

    if (allowSelection) {
      allowSelection.addEventListener("click", function (event) {
        openModal(root, event.currentTarget);
      });
    }

    if (necessaryOnly) {
      necessaryOnly.addEventListener("click", function () {
        applyConsent(root, { preferences: false, analytics: false, marketing: false });
      });
    }

    if (save) {
      save.addEventListener("click", function () {
        applyConsent(root, collectModalSelection(root));
      });
    }

    modalCloseEls.forEach(function (btn) {
      btn.addEventListener("click", function () {
        closeModal(root);
      });
    });

    if (manage) {
      manage.addEventListener("click", function (event) {
        openModal(root, event.currentTarget);
      });
    }

    document.addEventListener("keydown", function (event) {
      if (!isModalOpen(root)) return;
      if (event.key === "Escape") {
        event.preventDefault();
        closeModal(root);
        return;
      }
      trapModalTab(root, event);
    });

    bindGlobalOpenHandler(root);

    if (banner) setVisible(banner, false);
  }

  function start() {
    var root = bySel(selectors.root);
    watchNativeBannerLegalLinks();

    if (!getBool(cfg.enabled)) {
      log("CMP disabled by settings, load scripts directly");
      loadGA();
      loadGTM();
      return;
    }

    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    if (root) {
      root.hidden = true;
      root.setAttribute("aria-hidden", "true");
      setVisible(bySel(selectors.banner, root), false);
      setVisible(bySel(selectors.modal, root), false);
      setVisible(bySel(selectors.manage, root), false);
      log("custom cmp ui hidden (native banner mode)");
    }

    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          log("customerPrivacy unavailable", error);
          hideBanner(root);
          setVisible(bySel(selectors.manage, root), false);
          return;
        }

        state.api = window.Shopify.customerPrivacy;
        log("customerPrivacy ready");
        if (!state.consentDefaultSet) {
          syncGtmConsentMode("default");
          state.consentDefaultSet = true;
        }

        var shouldShow = false;
        try {
          shouldShow = !!state.api.shouldShowBanner();
        } catch (e) {
          shouldShow = false;
        }

        log("shouldShowBanner", shouldShow);
        if (root) {
          setVisible(bySel(selectors.banner, root), false);
          setVisible(bySel(selectors.manage, root), false);
        }

        if (shouldShow && isNativeBannerDismissed()) {
          hideNativeBanner();
          syncDismissedConsentMode();
          log("native banner hidden by 24h dismiss window");
        }

        if (!shouldShow) {
          clearNativeBannerDismissedAt();
          syncGtmConsentMode("update");
          applyScriptGate();
        }

        document.addEventListener("visitorConsentCollected", function () {
          log("visitorConsentCollected");
          clearNativeBannerDismissedAt();
          syncGtmConsentMode("update");
          applyScriptGate();
        });
      }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
